
"use client";

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useOutsideClick } from "../hooks/useOutsideClick";
import { LoginForm } from "./forms/LoginForm";
import { RegisterForm } from "./forms/RegisterForm";
import { ForgotPasswordForm } from "./forms/ForgotPasswordForm";
const AuthModal = () => {
  const { isAuthModalOpen, closeAuthModal } = useAuth();
  const ref = useOutsideClick<HTMLDivElement>(closeAuthModal);
  const [view, setView] = useState<"login" | "register" | "forgotPassword">(
    "login",
  );

  useEffect(() => {
    if (isAuthModalOpen) setView("login");
  }, [isAuthModalOpen]);

  return (
    <AnimatePresence>
      {isAuthModalOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
        >
          <motion.div
            ref={ref}
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            className="relative bg-white rounded-xl shadow-2xl w-full max-w-md p-8 max-h-[90vh] overflow-y-auto"
          >
            <button
              onClick={closeAuthModal}
              className="absolute top-4 right-4 p-1 rounded-full text-stone-400 hover:bg-stone-100 transition-colors z-10"
            >
              <X size={20} />
            </button>
            <AnimatePresence mode="wait">
              {view === "login" && (
                <LoginForm
                  onSwitchToRegister={() => setView("register")}
                  onSwitchToForgot={() => setView("forgotPassword")}
                  onSuccess={closeAuthModal}
                />
              )}
              {view === "register" && (
                <RegisterForm
                  onSwitchToLogin={() => setView("login")}
                  onSuccess={closeAuthModal}
                />
              )}
              {view === "forgotPassword" && (
                <ForgotPasswordForm onSwitchToLogin={() => setView("login")} />
              )}
            </AnimatePresence>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AuthModal;
